import { PROCESS } from "@/data/content";
import { Reveal, MaskedLines, Eyebrow } from "./Reveal";

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative bg-brand-navy py-28 text-white lg:py-40">
    <div className="absolute left-1/2 top-0 h-[400px] w-[700px] -translate-x-1/2 rounded-full bg-brand-indigo/30 blur-[160px]" />
    <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow n="05" label="How it works" light /></Reveal>
          <MaskedLines
            as="h2"
            inView
            delay={0.1}
            className="mt-6 font-display text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl"
            lines={["From first call", "to a working remote team."]}
          />
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <p className="text-base leading-relaxed text-white/60 md:text-lg">
            Four steps, honest timelines. Good people take a few weeks to find and train properly — we'd rather tell you that
            up front than rush someone onto your account.
          </p>
        </Reveal>
      </div>

      <div className="relative mt-20 grid gap-6 lg:grid-cols-4">
        <div className="absolute left-0 right-0 top-7 hidden h-px bg-gradient-to-r from-brand-cyan/0 via-brand-cyan/40 to-brand-cyan/0 lg:block" />
        {PROCESS.map((p, i) => (
          <Reveal key={p.n} delay={0.1 * i} data-testid={`process-step-${i + 1}`} className="group relative">
            <div className="relative z-10 grid h-[6.5rem] place-items-start">
              <span className="grid h-14 w-14 place-items-center rounded-full border border-brand-cyan/40 bg-brand-navy font-mono text-sm text-brand-cyan transition-all duration-500 group-hover:bg-brand-cyan group-hover:text-brand-navy group-hover:shadow-[0_0_30px_rgba(79,195,232,.5)]">
                {p.n}
              </span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-brand-cyan/80">{p.time}</div>
            <h3 className="mt-3 font-display text-xl font-semibold tracking-tight sm:text-2xl">{p.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/60 sm:text-base">{p.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
